<template>
  <div class="container">
    <!-- survey.js 컴포넌트 삽입-->
    <survey :survey="survey"></survey>
    <div id='surveyResult'></div>

    <h3>공제분 상세내역</h3>
    <table id='incomeTable' class="table">
        <thead>
            <tr>
                <th>구분</th>
                <th class='text-center'>근로자부담분</th>
                <th class='text-center'>사업자부담분</th>
            </tr>
        </thead>
        <tbody>

            <tr>
                <td>국민연금</td>
                <td class='text-right'>{{ toCurrency(data.국민연금_근로자) }}</td>
                <td class='text-right'>{{ toCurrency(data.국민연금_사업자) }}</td>
            </tr>
            <tr>
                <td>건강보험</td>
                <td class='text-right'>{{toCurrency(data.건강보험_근로자)}}</td>
                <td class='text-right'>{{toCurrency(data.건강보험_사업자)}}</td>
            </tr>
            <tr>
                <td>장기요양보험</td>
                <td class='text-right'>{{toCurrency(data.장기요양보험_근로자)}}</td>
                <td class='text-right'>{{toCurrency(data.장기요양보험_사업자)}}</td>
            </tr>
            <tr>
                <td>고용보험</td>
                <td class='text-right'>{{toCurrency(data.고용보험_근로자)}}</td>
                <td class='text-right'>{{toCurrency(data.고용보험_사업자)}}</td>
            </tr>
            <!--
            <tr>
                <td>산재보험</td>
                <td class='text-right'>0</td>
                <td class='text-right'>0</td>
            </tr>
            -->
            <tr>
                <td>소득세</td>
                <td class='text-right'>{{toCurrency(data.소득세)}}</td>
                <td class='text-right'>0</td>
            </tr>
            <tr>
                <td>지방세</td>
                <td class='text-right'>{{toCurrency(data.지방세)}}</td>
                <td class='text-right'>0</td>
            </tr>            
            <tr>
                <td>공제액합계</td>
                <td class='text-right'>{{toCurrency(data.공제액합계_근로자)}}</td>
                <td class='text-right'>{{toCurrency(data.공제액합계_사업자)}}</td>
            </tr>
        </tbody>
    </table>
  </div>
    
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.29.1/moment.min.js"></script>

<script>
// surveyJS를 import한다
import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";
import numeral from "numeral";
//import moment from 'moment';
//import axios from 'axios' 
import fs from 'fs'

// surveyJS에서 Survey 컴포넌트만 따로 빼낸다
var Survey = SurveyVue.Survey;

// surveyJS 스타일 설정
Survey.cssType = "bootstrap";

export default {
methods : {
    toCurrency(value) {
        return numeral(value).format("0,0")
    }
},
components: {
    // SurveyJS 컴포넌트 사용
    Survey
  },
  data() {

    // data() {}, computed : {} 둘다 가능
    //Papa.parse('../assets/withholding_tax_table.csv', config)
    
    var data = {
        연봉 : 0,
        월급 : 0,
        비과세급여 : 0,
        과세급여 : 0,
        부양가족수 : 1,
        취학자녀수 : 0,
        공제대상가족수: 1,
        사업장유형 : 0.0025,
        국민연금_근로자 : 0,
        국민연금_사업자 : 0,
        건강보험_근로자 : 0,
        건강보험_사업자 : 0,
        장기요양보험_근로자 : 0,
        장기요양보험_사업자 : 0,
        고용보험_근로자 : 0,
        고용보험_사업자 : 0,
        소득세 : 0,
        지방세 : 0,
        공제액합계_근로자 : 0,
        공제액합계_사업자 : 0,
        실수령액 : 0,
    }

    var json = {
        //title: "과소신고(초과환급)가산세",
        showNavigationButtons: false,
        //showCompletedPage: false,
        requiredText: "(필수)",
        pages: [
            {
                questions: [
                    {
                        type: "radiogroup",
                        name: "급여기준",
                        title: "급여산정 기준",
                        colCount: 2,
                        choices: ["월급", "연봉"],
                        defaultValue : "월급",
                        isRequired: true,
                    },
                    {
                        type: "text",
                        inputType: "currency",
                        id: "연봉",
                        name: "연봉",
                        title: "연봉을 입력하세요.",
                        visibleIf: "{급여기준}=='연봉'",
                        //isRequired: true,
                    },
                    {
                        type: "text",
                        inputType: "currency",
                        name: "월급",
                        title: "월급여액을 입력하세요.",
                        //visibleIf: "{급여기준}!='연봉'",
                        //isRequired: true,
                    },
                    {
                        type: "text",
                        inputType: "currency",
                        name: "비과세급여",
                        title: "월급 중 비과세 대상 급여",
                        defaultValue: "100,000",
                        isRequired: true,
                        //visibleIf: "{TOBE세액} notempty"
                    },
                    {
                        type: "text",
                        inputType: "currency",
                        name: "과세급여",
                        title: "과세대상급여",
                        //defaultValueExpression: "{총급여}-{비과세급여}",
                        readOnly: true
                    },
                    {
                        type: "dropdown",
                        name: "부양가족수",
                        title: "부양가족수(본인포함)",
                        showOptionsCaption: false,
                        colCount: 1,
                        choices: [1,2,3,4,5,6,7,8,9,10],
                        defaultValue: 1,
                        isRequired: true,
                    },
                    {
                        type: "dropdown",
                        name: "취학자녀수",
                        title: "7세이상 20세이하 자녀수",
                        description: "7세이상 20세이하 자녀가 있는 경우 공제대상 가족수에 가산",
                        showOptionsCaption: false,
                        colCount: 1,
                        choices: [0,1,2,3,4,5,6,7,8,9,10],
                        defaultValue: 0,
                    },
                    /*
                    {
                        type: "text",
                        name: "공제대상가족수",
                        title: "공제대상 가족수",
                        defaultValue: 1,
                        readOnly: true
                    },
                    */
                    {
                        type: "dropdown",
                        name: "사업장유형",
                        title: "사업장유형",
                        colCount: 1,
                        showOptionsCaption: false,
                        choices: [
                            {value:0.0025,text:"150인 미만기업"},
                            {value:0.0045,text:"150인 이상(우선지원대상기업)"},
                            {value:0.0065,text:"150인 이상 1000인 미만 기업"},
                            {value:0.0085,text:"1000인 이상, 국가, 지방자치단체"},
                        ],
                        defaultValue: 0.0025,
                        isRequired: true,
                    },
                    {
                        type: "text",
                        name: "공제액합계",
                        title: "공제액합계",
                        readOnly: true,
                    },
                    {
                        type: "text",
                        name: "실수령액",
                        title: "실수령액",
                        readOnly: true,
                    },

]
            }
        ],
        
    };

    // 모델 로드
    var surveyModel = new SurveyVue.Model(json);
    
    var 감면율 = 0;

    // 로케일 설정
    surveyModel.locale = 'ko';    

    // 모델이 렌더링 된다음 입력항목에 대한 이벤트 추가
    surveyModel.onAfterRenderQuestionInput.add(function (survey, options) {

        // 타이핑 이벤트 추가 -> 통화
        $("input.form-control,select.form-control").on("input", function () {

            if ($(this).attr('type') == "currency") {
                $(this).val(numeral($(this).val()).format("0,0"));
            }

        });
        
        // 아이폰에서 이벤트 처리 안되는 부분 고려해서 수정
        $("#sq_101i").on("input", function () {

            data.월급 = numeral($("#sq_101i").val()).value() / 12;
            $("#sq_102i").val(
                numeral(data.월급).format("0,0")
            );
            survey.setValue("월급",numeral(data.월급).format("0,0"));
        })

        $("#sq_101i,#sq_102i,#sq_103i").on("input", function () {
            data.월급 = numeral($("#sq_102i").val()).value();
            data.과세급여 = Math.max(0,Math.floor( (data.월급 - numeral($("#sq_103i").val()).value())));
            $("#sq_104i").val(
                numeral(data.과세급여).format("0,0")
            );
            survey.setValue("과세급여",numeral(data.과세급여).format("0,0"));
        })

    });

    surveyModel.onValueChanged.add(function (survey, options) {

        data.부양가족수 = survey.getQuestionByName("부양가족수").value;
        if (options.name == "취약자녀수") {
            if (options.value > data.부양가족수 - 1) {
                alert("취학자녀수는 부양가족수(본인제외)를 초과할 수 없습니다.")
                survey.setValue("취학자녀수",0);
            }
        }

        data.공제대상가족수 = data.부양가족수 + survey.getQuestionByName("취학자녀수").value;
        data.과세급여 = numeral(survey.getQuestionByName("과세급여").value).value();

        if (data.과세급여/1000 < 770) {
            data.소득세 = 0;
            data.지방세 = 0;
        }

        if (data.과세급여/1000 >= 770) {

            for (var i=0;i<withholding_tax_table.length;i++) {

                // 간이공제표에 해당하는 경우
                if (withholding_tax_table[i][0]<=data.과세급여/1000 && withholding_tax_table[i][1]>data.과세급여/1000) {
                    
                    data.소득세 = withholding_tax_table[i][data.공제대상가족수+1];
                    data.지방세 = Math.floor(data.소득세/100)*10;
                    
                }
                
            }

        }

        if (data.과세급여/1000 > 10000) {

            var add_tax = 0;

            if (14000 >= data.과세급여/1000 && data.과세급여/1000 > 10000) {
                add_tax = (data.과세급여/1000 - 10000) * 0.98 * 0.35 * 1000
                //console.log(add_tax);
            }
            if (28000 >= data.과세급여/1000 && data.과세급여/1000 > 14000) {
                add_tax = (1372 + (data.과세급여/1000 - 14000) * 0.98 * 0.38) * 1000
            }
            if (30000 >= data.과세급여/1000 && data.과세급여/1000 > 28000) {
                add_tax = (6585.6 + (data.과세급여/1000 - 28000) * 0.98 * 0.4) * 1000
            }
            if (34000 >= data.과세급여/1000 && data.과세급여/1000 > 30000) {
                add_tax = (7369.6 + (data.과세급여/1000 - 30000) * 0.4) * 1000
            }
            if (87000 >= data.과세급여/1000 && data.과세급여/1000 > 45000) {
                add_tax = (13369.6 + (data.과세급여/1000 - 45000) * 0.42) * 1000
            }
            if (data.과세급여/1000 > 87000) {
                add_tax = (31009.6 + (data.과세급여/1000 - 87000) * 0.45) * 1000
            }

            data.소득세 = Math.floor((data.소득세 + add_tax)/10)*10;
            data.지방세 = Math.floor(data.소득세/100)*10;
            

        }

        
        var 국민연금_하한선 = 320000;
        var 국민연금_상한선 = 5030000;
        var 국민연금_보험료 = 0.045;
        var 국민연금_산정기준급여 = data.과세급여;

        if (국민연금_산정기준급여 <= 국민연금_하한선) {
            국민연금_산정기준급여 = 국민연금_하한선
        } else if (국민연금_산정기준급여 >= 국민연금_상한선) {
            국민연금_산정기준급여 = 국민연금_상한선
        }

        var 국민연금 = Math.floor(국민연금_산정기준급여 * 국민연금_보험료 / 10) * 10;

        data.국민연금_근로자 = 국민연금;
        data.국민연금_사업자 = 국민연금;


        // 건강보험 계산
        var 건강보험_하한선 = 280000;
        var 건강보험_상한선 = 99249040;
        var 건강보험_보험료 = 0.0343;
        var 건강보험장기_보험료 = 0.1152;
        var 건강보험_산정기준급여 = data.과세급여;
        
        if (건강보험_산정기준급여 <= 건강보험_하한선) {
            건강보험_산정기준급여 = 건강보험_하한선
        } else if (건강보험_산정기준급여 >= 건강보험_상한선) {
            건강보험_산정기준급여 = 건강보험_상한선
        }

        var 건강보험 = Math.floor(건강보험_산정기준급여 * 건강보험_보험료 / 10) * 10;        
        var 건강보험장기 = Math.floor(건강보험 * 건강보험장기_보험료 / 10) * 10;        

        data.건강보험_근로자 = 건강보험;
        data.건강보험_사업자 = 건강보험;
        data.장기요양보험_근로자 = 건강보험장기;
        data.장기요양보험_사업자 = 건강보험장기;


        // 고용보험 계산
        data.고용보험_근로자 = Math.floor(data.과세급여 * 0.008 / 10)*10;
        data.고용보험_사업자 = Math.floor(data.과세급여 * (0.008 + survey.getQuestionByName("사업장유형").value) / 10)*10;

        data.공제액합계_근로자 = data.국민연금_근로자 + data.건강보험_근로자 + data.장기요양보험_근로자 + data.고용보험_근로자 + data.소득세 + data.지방세;
        data.공제액합계_사업자 = data.국민연금_사업자 + data.건강보험_사업자 + data.장기요양보험_사업자 + data.고용보험_사업자;
        
        survey.setValue("공제액합계", numeral(data.공제액합계_근로자).format("0,0"));
        survey.setValue("실수령액", numeral(data.월급 - data.공제액합계_근로자).format("0,0"));

    })

    return {
      //survey 컴포넌트를 반환
      survey: surveyModel,
      data: data
    };
  }
};

const withholding_tax_table = [
    [770,775,0,0,0,0,0,0,0,0,0,0,0],
    [775,780,0,0,0,0,0,0,0,0,0,0,0],
    [780,785,0,0,0,0,0,0,0,0,0,0,0],
    [785,790,0,0,0,0,0,0,0,0,0,0,0],
    [790,795,0,0,0,0,0,0,0,0,0,0,0],
    [795,800,0,0,0,0,0,0,0,0,0,0,0],
    [800,805,0,0,0,0,0,0,0,0,0,0,0],
    [805,810,0,0,0,0,0,0,0,0,0,0,0],
    [810,815,0,0,0,0,0,0,0,0,0,0,0],
    [815,820,0,0,0,0,0,0,0,0,0,0,0],
    [820,825,0,0,0,0,0,0,0,0,0,0,0],
    [825,830,0,0,0,0,0,0,0,0,0,0,0],
    [830,835,0,0,0,0,0,0,0,0,0,0,0],
    [835,840,0,0,0,0,0,0,0,0,0,0,0],
    [840,845,0,0,0,0,0,0,0,0,0,0,0],
    [845,850,0,0,0,0,0,0,0,0,0,0,0],
    [850,855,0,0,0,0,0,0,0,0,0,0,0],
    [855,860,0,0,0,0,0,0,0,0,0,0,0],
    [860,865,0,0,0,0,0,0,0,0,0,0,0],
    [865,870,0,0,0,0,0,0,0,0,0,0,0],
    [870,875,0,0,0,0,0,0,0,0,0,0,0],
    [875,880,0,0,0,0,0,0,0,0,0,0,0],
    [880,885,0,0,0,0,0,0,0,0,0,0,0],
    [885,890,0,0,0,0,0,0,0,0,0,0,0],
    [890,895,0,0,0,0,0,0,0,0,0,0,0],
    [895,900,0,0,0,0,0,0,0,0,0,0,0],
    [900,905,0,0,0,0,0,0,0,0,0,0,0],
    [905,910,0,0,0,0,0,0,0,0,0,0,0],
    [910,915,0,0,0,0,0,0,0,0,0,0,0],
    [915,920,0,0,0,0,0,0,0,0,0,0,0],
    [920,925,0,0,0,0,0,0,0,0,0,0,0],
    [925,930,0,0,0,0,0,0,0,0,0,0,0],
    [930,935,0,0,0,0,0,0,0,0,0,0,0],
    [935,940,0,0,0,0,0,0,0,0,0,0,0],
    [940,945,0,0,0,0,0,0,0,0,0,0,0],
    [945,950,0,0,0,0,0,0,0,0,0,0,0],
    [950,955,0,0,0,0,0,0,0,0,0,0,0],
    [955,960,0,0,0,0,0,0,0,0,0,0,0],
    [960,965,0,0,0,0,0,0,0,0,0,0,0],
    [965,970,0,0,0,0,0,0,0,0,0,0,0],
    [970,975,0,0,0,0,0,0,0,0,0,0,0],
    [975,980,0,0,0,0,0,0,0,0,0,0,0],
    [980,985,0,0,0,0,0,0,0,0,0,0,0],
    [985,990,0,0,0,0,0,0,0,0,0,0,0],
    [990,995,0,0,0,0,0,0,0,0,0,0,0],
    [995,1000,0,0,0,0,0,0,0,0,0,0,0],
    [1000,1005,0,0,0,0,0,0,0,0,0,0,0],
    [1005,1010,0,0,0,0,0,0,0,0,0,0,0],
    [1010,1015,0,0,0,0,0,0,0,0,0,0,0],
    [1015,1020,0,0,0,0,0,0,0,0,0,0,0],
    [1020,1025,0,0,0,0,0,0,0,0,0,0,0],
    [1025,1030,0,0,0,0,0,0,0,0,0,0,0],
    [1030,1035,0,0,0,0,0,0,0,0,0,0,0],
    [1035,1040,0,0,0,0,0,0,0,0,0,0,0],
    [1040,1045,0,0,0,0,0,0,0,0,0,0,0],
    [1045,1050,0,0,0,0,0,0,0,0,0,0,0],
    [1050,1055,0,0,0,0,0,0,0,0,0,0,0],
    [1055,1060,0,0,0,0,0,0,0,0,0,0,0],
    [1060,1065,1040,0,0,0,0,0,0,0,0,0,0],
    [1065,1070,1110,0,0,0,0,0,0,0,0,0,0],
    [1070,1075,1180,0,0,0,0,0,0,0,0,0,0],
    [1075,1080,1250,0,0,0,0,0,0,0,0,0,0],
    [1080,1085,1320,0,0,0,0,0,0,0,0,0,0],
    [1085,1090,1390,0,0,0,0,0,0,0,0,0,0],
    [1090,1095,1460,0,0,0,0,0,0,0,0,0,0],
    [1095,1100,1530,0,0,0,0,0,0,0,0,0,0],
    [1100,1105,1600,0,0,0,0,0,0,0,0,0,0],
    [1105,1110,1670,0,0,0,0,0,0,0,0,0,0],
    [1110,1115,1740,0,0,0,0,0,0,0,0,0,0],
    [1115,1120,1810,0,0,0,0,0,0,0,0,0,0],
    [1120,1125,1880,0,0,0,0,0,0,0,0,0,0],
    [1125,1130,1950,0,0,0,0,0,0,0,0,0,0],
    [1130,1135,2020,0,0,0,0,0,0,0,0,0,0],
    [1135,1140,2090,0,0,0,0,0,0,0,0,0,0],
    [1140,1145,2160,0,0,0,0,0,0,0,0,0,0],
    [1145,1150,2230,0,0,0,0,0,0,0,0,0,0],
    [1150,1155,2300,0,0,0,0,0,0,0,0,0,0],
    [1155,1160,2370,0,0,0,0,0,0,0,0,0,0],
    [1160,1165,2440,0,0,0,0,0,0,0,0,0,0],
    [1165,1170,2500,0,0,0,0,0,0,0,0,0,0],
    [1170,1175,2570,0,0,0,0,0,0,0,0,0,0],
    [1175,1180,2640,0,0,0,0,0,0,0,0,0,0],
    [1180,1185,2710,0,0,0,0,0,0,0,0,0,0],
    [1185,1190,2780,0,0,0,0,0,0,0,0,0,0],
    [1190,1195,2850,0,0,0,0,0,0,0,0,0,0],
    [1195,1200,2920,0,0,0,0,0,0,0,0,0,0],
    [1200,1205,2990,0,0,0,0,0,0,0,0,0,0],
    [1205,1210,3060,0,0,0,0,0,0,0,0,0,0],
    [1210,1215,3130,0,0,0,0,0,0,0,0,0,0],
    [1215,1220,3200,0,0,0,0,0,0,0,0,0,0],
    [1220,1225,3270,0,0,0,0,0,0,0,0,0,0],
    [1225,1230,3340,0,0,0,0,0,0,0,0,0,0],
    [1230,1235,3410,0,0,0,0,0,0,0,0,0,0],
    [1235,1240,3480,0,0,0,0,0,0,0,0,0,0],
    [1240,1245,3550,0,0,0,0,0,0,0,0,0,0],
    [1245,1250,3620,0,0,0,0,0,0,0,0,0,0],
    [1250,1255,3700,0,0,0,0,0,0,0,0,0,0],
    [1255,1260,3810,0,0,0,0,0,0,0,0,0,0],
    [1260,1265,3910,0,0,0,0,0,0,0,0,0,0],
    [1265,1270,4010,0,0,0,0,0,0,0,0,0,0],
    [1270,1275,4120,0,0,0,0,0,0,0,0,0,0],
    [1275,1280,4220,0,0,0,0,0,0,0,0,0,0],
    [1280,1285,4320,0,0,0,0,0,0,0,0,0,0],
    [1285,1290,4430,0,0,0,0,0,0,0,0,0,0],
    [1290,1295,4530,0,0,0,0,0,0,0,0,0,0],
    [1295,1300,4630,0,0,0,0,0,0,0,0,0,0],
    [1300,1305,4740,0,0,0,0,0,0,0,0,0,0],
    [1305,1310,4840,0,0,0,0,0,0,0,0,0,0],
    [1310,1315,4940,0,0,0,0,0,0,0,0,0,0],
    [1315,1320,5050,0,0,0,0,0,0,0,0,0,0],
    [1320,1325,5150,0,0,0,0,0,0,0,0,0,0],
    [1325,1330,5250,0,0,0,0,0,0,0,0,0,0],
    [1330,1335,5360,0,0,0,0,0,0,0,0,0,0],
    [1335,1340,5460,0,0,0,0,0,0,0,0,0,0],
    [1340,1345,5560,1060,0,0,0,0,0,0,0,0,0],
    [1345,1350,5670,1170,0,0,0,0,0,0,0,0,0],
    [1350,1355,5770,1270,0,0,0,0,0,0,0,0,0],
    [1355,1360,5870,1370,0,0,0,0,0,0,0,0,0],
    [1360,1365,5980,1480,0,0,0,0,0,0,0,0,0],
    [1365,1370,6080,1580,0,0,0,0,0,0,0,0,0],
    [1370,1375,6180,1680,0,0,0,0,0,0,0,0,0],
    [1375,1380,6290,1790,0,0,0,0,0,0,0,0,0],
    [1380,1385,6390,1890,0,0,0,0,0,0,0,0,0],
    [1385,1390,6490,1990,0,0,0,0,0,0,0,0,0],
    [1390,1395,6600,2100,0,0,0,0,0,0,0,0,0],
    [1395,1400,6700,2200,0,0,0,0,0,0,0,0,0],
    [1400,1405,6800,2300,0,0,0,0,0,0,0,0,0],
    [1405,1410,6910,2410,0,0,0,0,0,0,0,0,0],
    [1410,1415,7010,2510,0,0,0,0,0,0,0,0,0],
    [1415,1420,7110,2610,0,0,0,0,0,0,0,0,0],
    [1420,1425,7210,2710,0,0,0,0,0,0,0,0,0],
    [1425,1430,7320,2820,0,0,0,0,0,0,0,0,0],
    [1430,1435,7420,2920,0,0,0,0,0,0,0,0,0],
    [1435,1440,7520,3020,0,0,0,0,0,0,0,0,0],
    [1440,1445,7630,3130,0,0,0,0,0,0,0,0,0],
    [1445,1450,7730,3230,0,0,0,0,0,0,0,0,0],
    [1450,1455,7830,3330,0,0,0,0,0,0,0,0,0],
    [1455,1460,7940,3440,0,0,0,0,0,0,0,0,0],
    [1460,1465,8040,3540,0,0,0,0,0,0,0,0,0],
    [1465,1470,8140,3640,0,0,0,0,0,0,0,0,0],
    [1470,1475,8250,3750,0,0,0,0,0,0,0,0,0],
    [1475,1480,8350,3850,0,0,0,0,0,0,0,0,0],
    [1480,1485,8450,3950,0,0,0,0,0,0,0,0,0],
    [1485,1490,8560,4060,0,0,0,0,0,0,0,0,0],
    [1490,1495,8660,4160,0,0,0,0,0,0,0,0,0],
    [1495,1500,8760,4260,0,0,0,0,0,0,0,0,0],
    [1500,1510,8920,4420,0,0,0,0,0,0,0,0,0],
    [1510,1520,9120,4620,0,0,0,0,0,0,0,0,0],
    [1520,1530,9330,4830,0,0,0,0,0,0,0,0,0],
    [1530,1540,9540,5040,0,0,0,0,0,0,0,0,0],
    [1540,1550,9740,5240,0,0,0,0,0,0,0,0,0],
    [1550,1560,9950,5450,0,0,0,0,0,0,0,0,0],
    [1560,1570,10160,5660,0,0,0,0,0,0,0,0,0],
    [1570,1580,10360,5860,0,0,0,0,0,0,0,0,0],
    [1580,1590,10570,6070,0,0,0,0,0,0,0,0,0],
    [1590,1600,10780,6280,0,0,0,0,0,0,0,0,0],
    [1600,1610,10980,6480,0,0,0,0,0,0,0,0,0],
    [1610,1620,11190,6690,0,0,0,0,0,0,0,0,0],
    [1620,1630,11400,6900,0,0,0,0,0,0,0,0,0],
    [1630,1640,11600,7100,0,0,0,0,0,0,0,0,0],
    [1640,1650,11810,7310,0,0,0,0,0,0,0,0,0],
    [1650,1660,12020,7520,0,0,0,0,0,0,0,0,0],
    [1660,1670,12220,7720,0,0,0,0,0,0,0,0,0],
    [1670,1680,12430,7930,0,0,0,0,0,0,0,0,0],
    [1680,1690,12640,8140,0,0,0,0,0,0,0,0,0],
    [1690,1700,12840,8340,0,0,0,0,0,0,0,0,0],
    [1700,1710,13050,8550,0,0,0,0,0,0,0,0,0],
    [1710,1720,13260,8760,0,0,0,0,0,0,0,0,0],
    [1720,1730,13460,8960,1040,0,0,0,0,0,0,0,0],
    [1730,1740,13670,9170,1240,0,0,0,0,0,0,0,0],
    [1740,1750,13880,9380,1440,0,0,0,0,0,0,0,0],
    [1750,1760,14080,9580,1640,0,0,0,0,0,0,0,0],
    [1760,1770,14290,9790,1830,0,0,0,0,0,0,0,0],
    [1770,1780,14500,10000,2030,0,0,0,0,0,0,0,0],
    [1780,1790,14700,10200,2230,0,0,0,0,0,0,0,0],
    [1790,1800,14910,10410,2430,0,0,0,0,0,0,0,0],
    [1800,1810,15110,10610,2630,0,0,0,0,0,0,0,0],
    [1810,1820,15320,10820,2830,0,0,0,0,0,0,0,0],
    [1820,1830,15530,11030,3020,0,0,0,0,0,0,0,0],
    [1830,1840,15730,11230,3220,0,0,0,0,0,0,0,0],
    [1840,1850,15940,11440,3420,0,0,0,0,0,0,0,0],
    [1850,1860,16150,11650,3620,0,0,0,0,0,0,0,0],
    [1860,1870,16350,11850,3820,0,0,0,0,0,0,0,0],
    [1870,1880,16560,12060,4020,0,0,0,0,0,0,0,0],
    [1880,1890,16770,12270,4220,0,0,0,0,0,0,0,0],
    [1890,1900,16970,12470,4410,1040,0,0,0,0,0,0,0],
    [1900,1910,17180,12680,4610,1240,0,0,0,0,0,0,0],
    [1910,1920,17390,12890,4810,1440,0,0,0,0,0,0,0],
    [1920,1930,17590,13090,5010,1630,0,0,0,0,0,0,0],
    [1930,1940,17800,13300,5210,1830,0,0,0,0,0,0,0],
    [1940,1950,18010,13510,5410,2030,0,0,0,0,0,0,0],
    [1950,1960,18210,13710,5600,2230,0,0,0,0,0,0,0],
    [1960,1970,18420,13920,5800,2430,0,0,0,0,0,0,0],
    [1970,1980,18630,14130,6000,2630,0,0,0,0,0,0,0],
    [1980,1990,18880,14330,6200,2820,0,0,0,0,0,0,0],
    [1990,2000,19200,14540,6400,3020,0,0,0,0,0,0,0],
    [2000,2010,19520,14750,6600,3220,0,0,0,0,0,0,0],
    [2010,2020,19850,14950,6800,3420,0,0,0,0,0,0,0],
    [2020,2030,20170,15160,6990,3620,0,0,0,0,0,0,0],
    [2030,2040,20490,15370,7190,3820,0,0,0,0,0,0,0],
    [2040,2050,20810,15570,7390,4020,0,0,0,0,0,0,0],
    [2050,2060,21130,15780,7590,4210,0,0,0,0,0,0,0],
    [2060,2070,21450,15990,7790,4410,1040,0,0,0,0,0,0],
    [2070,2080,21770,16190,7990,4610,1240,0,0,0,0,0,0],
    [2080,2090,22090,16400,8180,4810,1430,0,0,0,0,0,0],
    [2090,2100,22420,16600,8380,5010,1630,0,0,0,0,0,0],
    [2100,2110,22740,16810,8580,5210,1830,0,0,0,0,0,0],
    [2110,2120,23060,17020,8780,5400,2030,0,0,0,0,0,0],
    [2120,2130,23380,17220,8980,5600,2230,0,0,0,0,0,0],
    [2130,2140,23700,17430,9180,5800,2430,0,0,0,0,0,0],
    [2140,2150,24020,17640,9380,6000,2630,0,0,0,0,0,0],
    [2150,2160,24340,17840,9570,6200,2820,0,0,0,0,0,0],
    [2160,2170,24660,18050,9770,6400,3020,0,0,0,0,0,0],
    [2170,2180,24990,18260,9970,6600,3220,0,0,0,0,0,0],
    [2180,2190,25310,18460,10170,6790,3420,0,0,0,0,0,0],
    [2190,2200,25630,18670,10370,6990,3620,0,0,0,0,0,0],
    [2200,2210,25950,18950,10570,7190,3820,0,0,0,0,0,0],
    [2210,2220,26270,19270,10760,7390,4010,0,0,0,0,0,0],
    [2220,2230,26590,19590,10960,7590,4210,0,0,0,0,0,0],
    [2230,2240,26910,19910,11160,7790,4410,1040,0,0,0,0,0],
    [2240,2250,27240,20240,11360,7980,4610,1230,0,0,0,0,0],
    [2250,2260,27560,20560,11560,8180,4810,1430,0,0,0,0,0],
    [2260,2270,27880,20880,11760,8380,5010,1630,0,0,0,0,0],
    [2270,2280,28200,21200,11960,8580,5210,1830,0,0,0,0,0],
    [2280,2290,28520,21520,12150,8780,5400,2030,0,0,0,0,0],
    [2290,2300,28840,21840,12350,8980,5600,2230,0,0,0,0,0],
    [2300,2310,29160,22160,12550,9180,5800,2430,0,0,0,0,0],
    [2310,2320,29480,22480,12750,9370,6000,2620,0,0,0,0,0],
    [2320,2330,29810,22810,12950,9570,6200,2820,0,0,0,0,0],
    [2330,2340,30130,23130,13150,9770,6400,3020,0,0,0,0,0],
    [2340,2350,30450,23450,13340,9970,6590,3220,0,0,0,0,0],
    [2350,2360,30770,23770,13540,10170,6790,3420,0,0,0,0,0],
    [2360,2370,31090,24090,13740,10370,6990,3620,0,0,0,0,0],
    [2370,2380,31410,24410,13940,10560,7190,3810,0,0,0,0,0],
    [2380,2390,31970,24730,14140,10760,7390,4010,0,0,0,0,0],
    [2390,2400,32770,25050,14340,10960,7590,4210,0,0,0,0,0],
    [2400,2410,33570,25380,14530,11160,7780,4410,1030,0,0,0,0],
    [2410,2420,34380,25700,14730,11360,7980,4610,1230,0,0,0,0],
    [2420,2430,35180,26020,14930,11560,8180,4810,1430,0,0,0,0],
    [2430,2440,35980,26340,15130,11760,8380,5010,1630,0,0,0,0],
    [2440,2450,36790,26660,15330,11950,8580,5200,1830,0,0,0,0],
    [2450,2460,37590,26980,15530,12150,8780,5400,2030,0,0,0,0],
    [2460,2470,38390,27300,15730,12350,8980,5600,2230,0,0,0,0],
    [2470,2480,39200,27630,15920,12550,9170,5800,2420,0,0,0,0],
    [2480,2490,40000,27950,16120,12750,9370,6000,2620,0,0,0,0],
    [2490,2500,40800,28270,16320,12950,9570,6200,2820,0,0,0,0],
    [2500,2510,41630,28600,16530,13150,9780,6400,3030,0,0,0,0],
    [2510,2520,42490,28940,16740,13360,9990,6610,3240,0,0,0,0],
    [2520,2530,43340,29280,16950,13580,10200,6830,3450,0,0,0,0],
    [2530,2540,44200,29630,17160,13790,10410,7040,3660,0,0,0,0],
    [2540,2550,45050,29970,17370,14000,10620,7250,3870,0,0,0,0],
    [2550,2560,45910,30310,17590,14210,10840,7460,4090,0,0,0,0],
    [2560,2570,46770,30650,17800,14420,11050,7670,4300,0,0,0,0],
    [2570,2580,47620,31000,18010,14630,11260,7880,4510,1130,0,0,0],
    [2580,2590,48480,31340,18220,14850,11470,8100,4720,1350,0,0,0],
    [2590,2600,49330,31830,18430,15060,11680,8310,4930,1560,0,0,0],
    [2600,2610,50190,32690,18650,15270,11900,8520,5150,1770,0,0,0],
    [2610,2620,51040,33540,18920,15480,12110,8730,5360,1980,0,0,0],
    [2620,2630,51900,34400,19250,15690,12320,8940,5570,2190,0,0,0],
    [2630,2640,52760,35260,19580,15910,12530,9160,5780,2410,0,0,0],
    [2640,2650,53610,36110,19910,16120,12740,9370,5990,2620,0,0,0],
    [2650,2660,54470,36970,20240,16330,12960,9580,6210,2830,0,0,0],
    [2660,2670,55320,37820,20570,16540,13170,9790,6420,3040,0,0,0],
    [2670,2680,56180,38680,20900,16750,13380,10000,6630,3250,0,0,0],
    [2680,2690,57040,39540,21230,16970,13590,10220,6840,3470,0,0,0],
    [2690,2700,57890,40390,21560,17180,13800,10430,7050,3680,0,0,0],
    [2700,2710,58750,41250,21890,17390,14020,10640,7270,3890,0,0,0],
    [2710,2720,59600,42100,22220,17600,14230,10850,7480,4100,0,0,0],
    [2720,2730,60460,42960,22550,17810,14440,11060,7690,4310,0,0,0],
    [2730,2740,61310,43810,22880,18030,14650,11280,7900,4530,1150,0,0],
    [2740,2750,62170,44670,23210,18240,14860,11490,8110,4740,1360,0,0],
    [2750,2760,63030,45530,23540,18450,15070,11700,8320,4950,1570,0,0],
    [2760,2770,63880,46380,23870,18660,15290,11910,8540,5160,1790,0,0],
    [2770,2780,64740,47240,24200,18950,15500,12120,8750,5370,2000,0,0],
    [2780,2790,65590,48090,24520,19270,15710,12340,8960,5590,2210,0,0],
    [2790,2800,66450,48950,24850,19600,15920,12550,9170,5800,2420,0,0],
    [2800,2810,67300,49800,25180,19930,16130,12760,9380,6010,2630,0,0],
    [2810,2820,68160,50660,25510,20260,16350,12970,9600,6220,2850,0,0],
    [2820,2830,69020,51520,25840,20590,16560,13180,9810,6430,3060,0,0],
    [2830,2840,69870,52370,26170,20920,16770,13400,10020,6650,3270,0,0],
    [2840,2850,70730,53230,26500,21250,16980,13610,10230,6860,3480,0,0],
    [2850,2860,71580,54080,26830,21580,17190,13820,10440,7070,3690,0,0],
    [2860,2870,72440,54940,27160,21910,17410,14030,10660,7280,3910,0,0],
    [2870,2880,73290,55790,27490,22240,17620,14240,10870,7490,4120,0,0],
    [2880,2890,74150,56650,27820,22570,17830,14460,11080,7710,4330,0,0],
    [2890,2900,75010,57510,28150,22900,18040,14670,11290,7920,4540,1170,0],
    [2900,2910,75860,58360,28480,23230,18250,14880,11500,8130,4750,1380,0],
    [2910,2920,76720,59220,28810,23560,18470,15090,11720,8340,4970,1590,0],
    [2920,2930,77570,60070,29140,23890,18680,15300,11930,8550,5180,1800,0],
    [2930,2940,78430,60930,29470,24220,18970,15510,12140,8760,5390,2010,0],
    [2940,2950,79280,61780,29800,24550,19300,15730,12350,8980,5600,2230,0],
    [2950,2960,80140,62640,30130,24880,19630,15940,12560,9190,5810,2440,0],
    [2960,2970,81000,63500,30460,25210,19960,16150,12780,9400,6030,2650,0],
    [2970,2980,81850,64350,30790,25540,20290,16360,12990,9610,6240,2860,0],
    [2980,2990,82710,65210,31120,25870,20620,16570,13200,9820,6450,3070,0],
    [2990,3000,83560,66060,31450,26200,20950,16790,13410,10040,6660,3290,0],
    [3000,3020,84850,67350,32490,26690,21440,17100,13730,10350,6980,3600,0],
    [3020,3040,86560,69060,34140,27350,22100,17530,14150,10780,7400,4030,0],
    [3040,3060,88270,70770,35790,28010,22760,17950,14580,11200,7830,4450,1080],
    [3060,3080,89980,72480,37440,28670,23420,18380,15000,11630,8250,4880,1500],
    [3080,3100,91690,74190,39080,29330,24080,18830,15430,12050,8680,5300,1930],
    [3100,3120,93400,75900,40730,29990,24740,19490,15850,12470,9100,5720,2350],
    [3120,3140,95760,77620,42380,30650,25400,20150,16270,12900,9520,6150,2770],
    [3140,3160,98210,79330,44030,31310,26060,20810,16700,13320,9950,6570,3200],
    [3160,3180,100650,81040,45680,32550,26720,21470,17120,13750,10370,7000,3620],
    [3180,3200,103100,82750,47330,34200,27380,22130,17540,14170,10790,7420,4040],
    [3200,3220,105540,84460,48980,35850,28040,22790,17970,14590,11220,7840,4470],
    [3220,3240,107990,86170,50620,37500,28700,23450,18390,15020,11640,8270,4890],
    [3240,3260,110430,87880,52270,39150,29360,24110,18860,15440,12070,8690,5320],
    [3260,3280,112880,89600,53920,40800,30020,24770,19520,15870,12490,9120,5740],
    [3280,3300,115320,91310,55570,42440,30670,25420,20170,16290,12910,9540,6160],
    [3300,3320,117770,93020,57220,44090,31330,26080,20830,16710,13340,9960,6590],
    [3320,3340,120210,95210,58870,45740,32620,26740,21490,17140,13760,10390,7010],
    [3340,3360,122660,97660,60440,47320,34190,27370,22120,17540,14170,10790,7420],
    [3360,3380,125100,100100,62010,48880,35760,28000,22750,17950,14570,11200,7820],
    [3380,3400,127550,102550,63570,50450,37320,28630,23380,18350,14970,11600,8220],
    [3400,3420,129990,104990,65140,52010,38890,29250,24000,18750,15370,12000,8620],
    [3420,3440,132440,107440,66700,53580,40450,29880,24630,19380,15780,12400,9030],
    [3440,3460,134880,109880,68270,55140,42020,30500,25250,20000,16180,12800,9430],
    [3460,3480,137330,112330,69830,56710,43580,31130,25880,20630,16580,13210,9830],
    [3480,3500,139770,114770,71400,58270,45150,32020,26510,21260,16980,13610,10230],
    [3500,3520,142220,117220,72960,59840,46710,33590,27130,21880,17390,14010,10640],
    [3520,3540,144660,119660,74530,61400,48280,35150,27760,22510,17790,14410,11040],
    [3540,3560,147110,122110,76090,62960,49840,36710,28380,23130,18190,14820,11440],
    [3560,3580,149550,124550,77650,64530,51400,38280,29010,23760,18590,15220,11840],
    [3580,3600,152000,127000,79220,66090,52970,39840,29630,24380,19130,15620,12250],
    [3600,3620,154440,129440,80780,67660,54530,41410,30260,25010,19760,16020,12650],
    [3620,3640,156890,131890,82350,69220,56100,42970,30890,25640,20390,16420,13050],
    [3640,3660,159330,134330,83910,70790,57660,44540,31510,26260,21010,16830,13450],
    [3660,3680,161780,136780,85480,72350,59230,46100,32980,26890,21640,17230,13850],
    [3680,3700,164220,139220,87040,73920,60790,47670,34540,27510,22260,17630,14260],
    [3700,3720,166670,141670,88610,75480,62360,49230,36110,28140,22890,18030,14660],
    [3720,3740,169110,144110,90170,77050,63920,50800,37670,28770,23520,18440,15060],
    [3740,3760,171560,146560,91730,78610,65480,52360,39230,29390,24140,18890,15460],
    [3760,3780,178920,151090,95250,81630,68510,55380,42260,30600,25350,20100,16240],
    [3780,3800,181590,153740,97700,83350,70220,57100,43970,31290,26040,20790,16680],
    [3800,3820,184260,156400,100140,85060,71930,58810,45680,32560,26720,21470,17120],
    [3820,3840,186930,159050,102590,86770,73640,60520,47390,34270,27400,22150,17560],
    [3840,3860,189600,161710,105030,88480,75350,62230,49100,35980,28090,22840,18000],
    [3860,3880,192270,164360,107480,90190,77070,63940,50820,37690,28770,23520,18440],
    [3880,3900,194940,167020,109920,91900,78780,65650,52530,39400,29460,24210,18960],
    [3900,3920,197610,169670,112370,93620,80490,67360,54240,41110,30140,24890,19640],
    [3920,3940,200280,172330,114810,96060,82200,69080,55950,42830,30830,25580,20330],
    [3940,3960,202950,174980,117260,98510,83910,70790,57660,44540,31510,26260,21010],
    [3960,3980,205620,177640,119700,100950,85620,72500,59370,46250,33120,26950,21700],
    [3980,4000,208290,180290,122150,103400,87340,74210,61090,47960,34840,27630,22380],
    [4000,4020,210960,182950,124590,105840,89050,75920,62800,49670,36550,28320,23070],
    [4020,4040,213630,185600,127040,108290,90760,77630,64510,51380,38260,29000,23750],
    [4040,4060,216300,188260,129480,110730,92470,79340,66220,53090,39970,29680,24430],
    [4060,4080,218970,190910,131930,113180,94430,81060,67930,54810,41680,30370,25120],
    [4080,4100,221640,193570,134370,115620,96870,82770,69640,56520,43390,31050,25800],
    [4100,4120,224310,196220,136820,118070,99320,84480,71350,58230,45100,31980,26490],
    [4120,4140,226980,198880,139260,120510,101760,86190,73070,59940,46820,33690,27170],
    [4140,4160,229650,201530,141710,122960,104210,87900,74780,61650,48530,35400,27860],
    [4160,4180,232320,204190,144150,125400,106650,89610,76490,63360,50240,37110,28540],
    [4180,4200,234990,206840,146600,127850,109100,91330,78200,65080,51950,38830,29230],
    [4200,4220,237660,209500,149040,130290,111540,93040,79910,66790,53660,40540,29910],
    [4220,4240,240330,212150,151490,132740,113990,95240,81620,68500,55370,42250,30600],
    [4240,4260,243000,214810,153930,135180,116430,97680,83330,70210,57080,43960,31280],
    [4260,4280,245670,217460,156380,137630,118880,100130,85050,71920,58800,45670,32550],
    [4280,4300,248340,220120,158820,140070,121320,102570,86760,73630,60510,47380,34260],
    [4300,4320,251010,222770,161270,142520,123770,105020,88470,75340,62220,49090,35970],
    [4320,4340,253680,225430,163710,144960,126210,107460,90180,77060,63930,50810,37680],
    [4340,4360,256350,228080,166160,147410,128660,109910,91890,78770,65640,52520,39390],
    [4360,4380,259020,230740,168600,149850,131100,112350,93600,80480,67350,54230,41100],
    [4380,4400,261690,233390,171050,152300,133550,114800,96050,82190,69070,55940,42820],
    [4400,4420,264360,236050,173490,154740,135990,117240,98490,83900,70780,57650,44530],
    [4420,4440,267030,238700,175940,157190,138440,119690,100940,85610,72490,59360,46240],
    [4440,4460,269700,241360,178380,159630,140880,122130,103380,87320,74200,61070,47950],
    [4460,4480,272370,244010,180830,162080,143330,124580,105830,89040,75910,62790,49660],
    [4480,4500,275040,246670,183270,164520,145770,127020,108270,90750,77620,64500,51370],
    [4500,4520,277840,249460,185850,167100,148350,129600,110850,92550,79430,66300,53180],
    [4520,4540,280650,252250,188430,169680,150930,132180,113430,94680,81230,68110,54980],
    [4540,4560,283450,255040,191010,172260,153510,134760,116010,97260,83040,69920,56790],
    [4560,4580,286260,257830,193590,174840,156090,137340,118590,99840,84850,71720,58600],
    [4580,4600,291560,263120,198670,179920,161170,142420,123670,104920,86650,73530,60400],
    [4600,4620,294370,265910,201250,182500,163750,145000,126250,107500,88750,75330,62210],
    [4620,4640,297170,268700,203830,185080,166330,147580,128830,110080,91330,77140,64010],
    [4640,4660,299980,271490,206410,187660,168910,150160,131410,112660,93910,78950,65820],
    [4660,4680,302780,274280,208990,190240,171490,152740,133990,115240,96490,80750,67630],
    [4680,4700,305590,277070,211570,192820,174070,155320,136570,117820,99070,82560,69430],
    [4700,4720,308390,279860,214150,195400,176650,157900,139150,120400,101650,84360,71240],
    [4720,4740,311200,282650,216730,197980,179230,160480,141730,122980,104230,86170,73040],
    [4740,4760,314000,285440,219310,200560,181810,163060,144310,125560,106810,88060,74850],
    [4760,4780,316810,288230,221890,203140,184390,165640,146890,128140,109390,90640,76660],
    [4780,4800,319610,291020,224470,205720,186970,168220,149470,130720,111970,93220,78460],
    [4800,4820,322420,293810,227050,208300,189550,170800,152050,133300,114550,95800,80270],
    [4820,4840,325220,296600,229630,210880,192130,173380,154630,135880,117130,98380,82070],
    [4840,4860,328030,299390,232210,213460,194710,175960,157210,138460,119710,100960,83880],
    [4860,4880,330830,302180,234790,216040,197290,178540,159790,141040,122290,103540,85690],
    [4880,4900,333640,304970,237370,218620,199870,181120,162370,143620,124870,106120,87490],
    [4900,4920,336440,307760,239950,221200,202450,183700,164950,146200,127450,108700,89950],
    [4920,4940,339250,310550,242530,223780,205030,186280,167530,148780,130030,111280,92530],
    [4940,4960,342050,313340,245110,226360,207610,188860,170110,151360,132610,113860,95110],
    [4960,4980,344860,316130,247690,228940,210190,191440,172690,153940,135190,116440,97690],
    [4980,5000,347660,318920,250270,231520,212770,194020,175270,156520,137770,119020,100270],
    [5000,5020,350470,321710,252850,234100,215350,196600,177850,159100,140350,121600,102850],
    [5020,5040,353270,324500,255430,236680,217930,199180,180430,161680,142930,124180,105430],
    [5040,5060,356080,327290,258010,239260,220510,201760,183010,164260,145510,126760,108010],
    [5060,5080,358880,330080,260590,241840,223090,204340,185590,166840,148090,129340,110590],
    [5080,5100,361690,332870,263170,244420,225670,206920,188170,169420,150670,131920,113170],
    [5100,5120,364490,335660,265750,247000,228250,209500,190750,172000,153250,134500,115750],
    [5120,5140,367300,338450,268330,249580,230830,212080,193330,174580,155830,137080,118330],
    [5140,5160,370100,341240,270910,252160,233410,214660,195910,177160,158410,139660,120910],
    [5160,5180,372910,344030,273490,254740,235990,217240,198490,179740,160990,142240,123490],
    [5180,5200,375710,346820,276070,257320,238570,219820,201070,182320,163570,144820,126070],
    [5200,5220,378520,349610,278650,259900,241150,222400,203650,184900,166150,147400,128650],
    [5220,5240,381320,352400,281230,262480,243730,224980,206230,187480,168730,149980,131230],
    [5240,5260,384130,355190,283810,265060,246310,227560,208810,190060,171310,152560,133810],
    [5260,5280,386930,357980,286390,267640,248890,230140,211390,192640,173890,155140,136390],
    [5280,5300,389740,360770,288970,270220,251470,232720,213970,195220,176470,157720,138970],
    [5300,5320,392540,363560,291550,272800,254050,235300,216550,197800,179050,160300,141550],
    [5320,5340,395350,366350,294130,275380,256630,237880,219130,200380,181630,162880,144130],
    [5340,5360,398150,369140,296710,277960,259210,240460,221710,202960,184210,165460,146710],
    [5360,5380,400960,371930,299290,280540,261790,243040,224290,205540,186790,168040,149290],
    [5380,5400,403760,374720,301870,283120,264370,245620,226870,208120,189370,170620,151870],
    [5400,5420,406570,377510,304450,285700,266950,248200,229450,210700,191950,173200,154450],
    [5420,5440,409370,380300,307030,288280,269530,250780,232030,213280,194530,175780,157030],
    [5440,5460,412180,383090,309610,290860,272110,253360,234610,215860,197110,178360,159610],
    [5460,5480,414980,385880,312190,293440,274690,255940,237190,218440,199690,180940,162190],
    [5480,5500,417790,388670,314770,296020,277270,258520,239770,221020,202270,183520,164770],
    [5500,5520,420590,391460,317350,298600,279850,261100,242350,223600,204850,186100,167350],
    [5520,5540,423400,394250,319930,301180,282430,263680,244930,226180,207430,188680,169930],
    [5540,5560,426200,397040,322510,303760,285010,266260,247510,228760,210010,191260,172510],
    [5560,5580,429010,399830,325090,306340,287590,268840,250090,231340,212590,193840,175090],
    [5580,5600,431810,402620,327670,308920,290170,271420,252670,233920,215170,196420,177670],
    [5600,5620,435890,405410,330250,311500,292750,274000,255250,236500,217750,199000,180250],
    [5620,5640,440380,408200,332830,314080,295330,276580,257830,239080,220330,201580,182830],
    [5640,5660,444860,410990,335410,316660,297910,279160,260410,241660,222910,204160,185410],
    [5660,5680,449350,413780,337990,319240,300490,281740,262990,244240,225490,206740,187990],
    [5680,5700,453840,416570,340570,321820,303070,284320,265570,246820,228070,209320,190570],
    [5700,5720,458330,419360,343150,324400,305650,286900,268150,249400,230650,211900,193150],
    [5720,5740,462820,422150,345730,326980,308230,289480,270730,251980,233230,214480,195730],
    [5740,5760,467300,424940,348310,329560,310810,292060,273310,254560,235810,217060,198310],
    [5760,5780,471790,427730,350890,332140,313390,294640,275890,257140,238390,219640,200890],
    [5780,5800,476280,430520,353470,334720,315970,297220,278470,259720,240970,222220,203470],
    [5800,5820,480770,433800,356050,337300,318550,299800,281050,262300,243550,224800,206050],
    [5820,5840,485260,438260,358630,339880,321130,302380,283630,264880,246130,227380,208630],
    [5840,5860,512120,465100,387100,368350,349600,330850,312100,293350,274600,255850,237100],
    [5860,5880,519150,472110,392240,373490,354740,335990,317240,298490,279740,260990,242240],
    [5880,5900,523690,476620,394880,376130,357380,338630,319880,301130,282380,263630,244880],
    [5900,5920,528220,481130,397520,378770,360020,341270,322520,303770,285020,266270,247520],
    [5920,5940,532760,485640,400160,381410,362660,343910,325160,306410,287660,268910,250160],
    [5940,5960,537300,490160,402800,384050,365300,346550,327800,309050,290300,271550,252800],
    [5960,5980,541830,494670,405440,386690,367940,349190,330440,311690,292940,274190,255440],
    [5980,6000,546370,499180,408080,389330,370580,351830,333080,314330,295580,276830,258080],
    [6000,6020,550900,503690,410720,391970,373220,354470,335720,316970,298220,279470,260720],
    [6020,6040,555440,508200,413360,394610,375860,357110,338360,319610,300860,282110,263360],
    [6040,6060,559980,512720,416000,397250,378500,359750,341000,322250,303500,284750,266000],
    [6060,6080,564510,517230,418640,399890,381140,362390,343640,324890,306140,287390,268640],
    [6080,6100,569050,521740,421280,402530,383780,365030,346280,327530,308780,290030,271280],
    [6100,6120,573580,526250,423920,405170,386420,367670,348920,330170,311420,292670,273920],
    [6120,6140,578120,530760,426560,407810,389060,370310,351560,332810,314060,295310,276560],
    [6140,6160,582660,535280,429200,410450,391700,372950,354200,335450,316700,297950,279200],
    [6160,6180,587190,539790,431840,413090,394340,375590,356840,338090,319340,300590,281840],
    [6180,6200,591730,544300,434480,415730,396980,378230,359480,340730,321980,303230,284480],
    [6200,6220,596260,548810,437120,418370,399620,380870,362120,343370,324620,305870,287120],
    [6220,6240,600800,553320,439760,421010,402260,383510,364760,346010,327260,308510,289760],
    [6240,6260,605340,557840,442400,423650,404900,386150,367400,348650,329900,311150,292400],
    [6260,6280,609870,562350,446060,426290,407540,388790,370040,351290,332540,313790,295040],
    [6280,6300,614410,566860,450280,428930,410180,391430,372680,353930,335180,316430,297680],
    [6300,6320,618940,571370,454510,431570,412820,394070,375320,356570,337820,319070,300320],
    [6320,6340,623480,575880,458730,434210,415460,396710,377960,359210,340460,321710,302960],
    [6340,6360,628020,580400,462960,436850,418100,399350,380600,361850,343100,324350,305600],
    [6360,6380,632550,584910,467180,439490,420740,401990,383240,364490,345740,326990,308240],
    [6380,6400,637090,589420,471400,442130,423380,404630,385880,367130,348380,329630,310880],
    [6400,6420,641620,593930,475630,445630,426020,407270,388520,369770,351020,332270,313520],
    [6420,6440,646160,598440,479850,449850,428660,409910,391160,372410,353660,334910,316160],
    [6440,6460,650700,602960,484080,454080,431300,412550,393800,375050,356300,337550,318800],
    [6460,6480,655230,607470,488300,458300,433940,415190,396440,377690,358940,340190,321440],
    [6480,6500,659770,611980,492520,462520,436580,417830,399080,380330,361580,342830,324080],
    [6500,6520,664300,616490,496750,466750,439220,420470,401720,382970,364220,345470,326720],
    [6520,6540,668840,621000,500970,470970,441860,423110,404360,385610,366860,348110,329360],
    [6540,6560,673380,625520,505200,475200,445200,425750,407000,388250,369500,350750,332000],
    [6560,6580,677910,630030,509420,479420,449420,428390,409640,390890,372140,353390,334640],
    [6580,6600,682450,634540,513640,483640,453640,431030,412280,393530,374780,356030,337280],
    [6600,6620,686980,639050,517870,487870,457870,433670,414920,396170,377420,358670,339920],
    [6620,6640,691520,643560,522090,492090,462090,436310,417560,398810,380060,361310,342560],
    [6640,6660,696060,648080,526320,496320,466320,438950,420200,401450,382700,363950,345200],
    [6660,6680,700590,652590,530540,500540,470540,441590,422840,404090,385340,366590,347840],
    [6680,6700,705130,657100,534760,504760,474760,444760,425480,406730,387980,369230,350480],
    [6700,6720,709660,661610,538990,508990,478990,448990,428120,409370,390620,371870,353120],
    [6720,6740,714200,666120,543210,513210,483210,453210,430760,412010,393260,374510,355760],
    [6740,6760,718740,670640,547440,517440,487440,457440,433400,414650,395900,377150,358400],
    [6760,6780,723270,675150,551660,521660,491660,461660,436040,417290,398540,379790,361040],
    [6780,6800,727810,679660,555880,525880,495880,465880,438680,419930,401180,382430,363680],
    [6800,6820,732340,684170,560110,530110,500110,470110,441320,422570,403820,385070,366320],
    [6820,6840,736880,688680,564330,534330,504330,474330,444330,425210,406460,387710,368960],
    [6840,6860,741420,693200,568560,538560,508560,478560,448560,427850,409100,390350,371600],
    [6860,6880,745950,697710,572780,542780,512780,482780,452780,430490,411740,392990,374240],
    [6880,6900,750490,702220,577000,547000,517000,487000,457000,433130,414380,395630,376880],
    [6900,6920,755020,706730,581230,551230,521230,491230,461230,435770,417020,398270,379520],
    [6920,6940,759560,711240,585450,555450,525450,495450,465450,438410,419660,400910,382160],
    [6940,6960,764100,715760,589680,559680,529680,499680,469680,441050,422300,403550,384800],
    [6960,6980,768630,720270,593900,563900,533900,503900,473900,443900,424940,406190,387440],
    [6980,7000,773170,724780,598120,568120,538120,508120,478120,448120,427580,408830,390080],
    [7000,7020,777700,729290,602350,572350,542350,512350,482350,452350,430220,411470,392720],
    [7020,7040,782240,733800,606570,576570,546570,516570,486570,456570,432860,414110,395360],
    [7040,7060,786780,738320,610800,580800,550800,520800,490800,460800,435500,416750,398000],
    [7060,7080,791310,742830,615020,585020,555020,525020,495020,465020,438140,419390,400640],
    [7080,7100,795850,747340,619240,589240,559240,529240,499240,469240,440780,422030,403280],
    [7100,7120,800380,751850,623470,593470,563470,533470,503470,473470,443470,424670,405920],
    [7120,7140,804920,756360,627690,597690,567690,537690,507690,477690,447690,427310,408560],
    [7140,7160,809460,760880,631920,601920,571920,541920,511920,481920,451920,429950,411200],
    [7160,7180,813990,765390,636140,606140,576140,546140,516140,486140,456140,432590,413840],
    [7180,7200,818530,769900,640360,610360,580360,550360,520360,490360,460360,435230,416480],
    [7200,7220,823060,774410,644590,614590,584590,554590,524590,494590,464590,437870,419120],
    [7220,7240,827600,778920,648810,618810,588810,558810,528810,498810,468810,440510,421760],
    [7240,7260,832140,783440,653040,623040,593040,563040,533040,503040,473040,443150,424400],
    [7260,7280,836670,787950,657260,627260,597260,567260,537260,507260,477260,447260,427040],
    [7280,7300,841210,792460,661480,631480,601480,571480,541480,511480,481480,451480,429680],
    [7300,7320,845740,796970,665710,635710,605710,575710,545710,515710,485710,455710,432320],
    [7320,7340,850280,801480,669930,639930,609930,579930,549930,519930,489930,459930,434960],
    [7340,7360,854820,806000,674160,644160,614160,584160,554160,524160,494160,464160,437600],
    [7360,7380,859350,810510,678380,648380,618380,588380,558380,528380,498380,468380,440240],
    [7380,7400,863890,815020,682600,652600,622600,592600,562600,532600,502600,472600,442880],
    [7400,7420,868420,819530,686830,656830,626830,596830,566830,536830,506830,476830,446830],
    [7420,7440,872960,824040,691050,661050,631050,601050,571050,541050,511050,481050,451050],
    [7440,7460,877500,828560,695280,665280,635280,605280,575280,545280,515280,485280,455280],
    [7460,7480,882030,833070,699500,669500,639500,609500,579500,549500,519500,489500,459500],
    [7480,7500,886570,837580,703720,673720,643720,613720,583720,553720,523720,493720,463720],
    [7500,7520,891100,842090,707950,677950,647950,617950,587950,557950,527950,497950,467950],
    [7520,7540,895640,846600,712170,682170,652170,622170,592170,562170,532170,502170,472170],
    [7540,7560,900180,851120,716400,686400,656400,626400,596400,566400,536400,506400,476400],
    [7560,7580,904710,855630,720620,690620,660620,630620,600620,570620,540620,510620,480620],
    [7580,7600,909250,860140,724840,694840,664840,634840,604840,574840,544840,514840,484840],
    [7600,7620,913780,864650,729070,699070,669070,639070,609070,579070,549070,519070,489070],
    [7620,7640,918320,869160,733290,703290,673290,643290,613290,583290,553290,523290,493290],
    [7640,7660,922860,873680,737520,707520,677520,647520,617520,587520,557520,527520,497520],
    [7660,7680,927390,878190,741740,711740,681740,651740,621740,591740,561740,531740,501740],
    [7680,7700,931930,882700,745960,715960,685960,655960,625960,595960,565960,535960,505960],
    [7700,7720,936460,887210,750190,720190,690190,660190,630190,600190,570190,540190,510190],
    [7720,7740,941000,891720,754410,724410,694410,664410,634410,604410,574410,544410,514410],
    [7740,7760,945540,896240,758640,728640,698640,668640,638640,608640,578640,548640,518640],
    [7760,7780,950070,900750,762860,732860,702860,672860,642860,612860,582860,552860,522860],
    [7780,7800,954610,905260,767080,737080,707080,677080,647080,617080,587080,557080,527080],
    [7800,7820,959140,909770,771310,741310,711310,681310,651310,621310,591310,561310,531310],
    [7820,7840,963680,914280,775530,745530,715530,685530,655530,625530,595530,565530,535530],
    [7840,7860,968220,918800,779760,749760,719760,689760,659760,629760,599760,569760,539760],
    [7860,7880,972750,923310,783980,753980,723980,693980,663980,633980,603980,573980,543980],
    [7880,7900,977290,927820,788200,758200,728200,698200,668200,638200,608200,578200,548200],
    [7900,7920,981820,932330,792430,762430,732430,702430,672430,642430,612430,582430,552430],
    [7920,7940,986360,936840,796650,766650,736650,706650,676650,646650,616650,586650,556650],
    [7940,7960,990900,941360,800880,770880,740880,710880,680880,650880,620880,590880,560880],
    [7960,7980,995430,945870,805100,775100,745100,715100,685100,655100,625100,595100,565100],
    [7980,8000,999970,950380,809320,779320,749320,719320,689320,659320,629320,599320,569320],
    [8000,8020,1004500,954890,813550,783550,753550,723550,693550,663550,633550,603550,573550],
    [8020,8040,1009040,959400,817770,787770,757770,727770,697770,667770,637770,607770,577770],
    [8040,8060,1013580,963920,822000,792000,762000,732000,702000,672000,642000,612000,582000],
    [8060,8080,1018110,968430,826220,796220,766220,736220,706220,676220,646220,616220,586220],
    [8080,8100,1022650,972940,830440,800440,770440,740440,710440,680440,650440,620440,590440],
    [8100,8120,1027180,977450,834670,804670,774670,744670,714670,684670,654670,624670,594670],
    [8120,8140,1031720,981960,838890,808890,778890,748890,718890,688890,658890,628890,598890],
    [8140,8160,1036260,986480,843120,813120,783120,753120,723120,693120,663120,633120,603120],
    [8160,8180,1040790,990990,847340,817340,787340,757340,727340,697340,667340,637340,607340],
    [8180,8200,1045330,995500,851560,821560,791560,761560,731560,701560,671560,641560,611560],
    [8200,8220,1049860,1000010,855790,825790,795790,765790,735790,705790,675790,645790,615790],
    [8220,8240,1054400,1004520,860010,830010,800010,770010,740010,710010,680010,650010,620010],
    [8240,8260,1058940,1009040,864240,834240,804240,774240,744240,714240,684240,654240,624240],
    [8260,8280,1063470,1013550,868460,838460,808460,778460,748460,718460,688460,658460,628460],
    [8280,8300,1068010,1018060,872680,842680,812680,782680,752680,722680,692680,662680,632680],
    [8300,8320,1072540,1022570,876910,846910,816910,786910,756910,726910,696910,666910,636910],
    [8320,8340,1077080,1027080,881130,851130,821130,791130,761130,731130,701130,671130,641130],
    [8340,8360,1081740,1031720,885480,855480,825480,795480,765480,735480,705480,675480,645480],
    [8360,8380,1086420,1036370,889840,859840,829840,799840,769840,739840,709840,679840,649840],
    [8380,8400,1091100,1041030,894210,864210,834210,804210,774210,744210,714210,684210,654210],
    [8400,8420,1095780,1045680,898580,868580,838580,808580,778580,748580,718580,688580,658580],
    [8420,8440,1100460,1050340,902950,872950,842950,812950,782950,752950,722950,692950,662950],
    [8440,8460,1105140,1055000,907320,877320,847320,817320,787320,757320,727320,697320,667320],
    [8460,8480,1109820,1059650,911680,881680,851680,821680,791680,761680,731680,701680,671680],
    [8480,8500,1114500,1064310,916050,886050,856050,826050,796050,766050,736050,706050,676050],
    [8500,8520,1119180,1068960,920420,890420,860420,830420,800420,770420,740420,710420,680420],
    [8520,8540,1123860,1073620,924790,894790,864790,834790,804790,774790,744790,714790,684790],
    [8540,8560,1128540,1078280,929160,899160,869160,839160,809160,779160,749160,719160,689160],
    [8560,8580,1133220,1082930,933520,903520,873520,843520,813520,783520,753520,723520,693520],
    [8580,8600,1137900,1087590,937890,907890,877890,847890,817890,787890,757890,727890,697890],
    [8600,8620,1142580,1092240,942260,912260,882260,852260,822260,792260,762260,732260,702260],
    [8620,8640,1147260,1096900,946630,916630,886630,856630,826630,796630,766630,736630,706630],
    [8640,8660,1151940,1101560,951000,921000,891000,861000,831000,801000,771000,741000,711000],
    [8660,8680,1156620,1106210,955360,925360,895360,865360,835360,805360,775360,745360,715360],
    [8680,8700,1161300,1110870,959730,929730,899730,869730,839730,809730,779730,749730,719730],
    [8700,8720,1165980,1115520,964100,934100,904100,874100,844100,814100,784100,754100,724100],
    [8720,8740,1170660,1120180,968470,938470,908470,878470,848470,818470,788470,758470,728470],
    [8740,8760,1175340,1124840,972840,942840,912840,882840,852840,822840,792840,762840,732840],
    [8760,8780,1180020,1129490,977200,947200,917200,887200,857200,827200,797200,767200,737200],
    [8780,8800,1184700,1134150,981570,951570,921570,891570,861570,831570,801570,771570,741570],
    [8800,8820,1189380,1138800,985940,955940,925940,895940,865940,835940,805940,775940,745940],
    [8820,8840,1194060,1143460,990310,960310,930310,900310,870310,840310,810310,780310,750310],
    [8840,8860,1198740,1148120,994680,964680,934680,904680,874680,844680,814680,784680,754680],
    [8860,8880,1203420,1152770,999040,969040,939040,909040,879040,849040,819040,789040,759040],
    [8880,8900,1208100,1157430,1003410,973410,943410,913410,883410,853410,823410,793410,763410],
    [8900,8920,1212780,1162080,1007780,977780,947780,917780,887780,857780,827780,797780,767780],
    [8920,8940,1217460,1166740,1012150,982150,952150,922150,892150,862150,832150,802150,772150],
    [8940,8960,1222140,1171400,1016520,986520,956520,926520,896520,866520,836520,806520,776520],
    [8960,8980,1226820,1176050,1020880,990880,960880,930880,900880,870880,840880,810880,780880],
    [8980,9000,1231500,1180710,1025250,995250,965250,935250,905250,875250,845250,815250,785250],
    [9000,9020,1236180,1185360,1029620,999620,969620,939620,909620,879620,849620,819620,789620],
    [9020,9040,1240860,1190020,1033990,1003990,973990,943990,913990,883990,853990,823990,793990],
    [9040,9060,1245540,1194680,1038360,1008360,978360,948360,918360,888360,858360,828360,798360],
    [9060,9080,1250220,1199330,1042720,1012720,982720,952720,922720,892720,862720,832720,802720],
    [9080,9100,1254900,1203990,1047090,1017090,987090,957090,927090,897090,867090,837090,807090],
    [9100,9120,1259580,1208640,1051460,1021460,991460,961460,931460,901460,871460,841460,811460],
    [9120,9140,1264260,1213300,1055830,1025830,995830,965830,935830,905830,875830,845830,815830],
    [9140,9160,1268940,1217960,1060200,1030200,1000200,970200,940200,910200,880200,850200,820200],
    [9160,9180,1273620,1222610,1064560,1034560,1004560,974560,944560,914560,884560,854560,824560],
    [9180,9200,1278300,1227270,1068930,1038930,1008930,978930,948930,918930,888930,858930,828930],
    [9200,9220,1282980,1231920,1073300,1043300,1013300,983300,953300,923300,893300,863300,833300],
    [9220,9240,1289640,1236580,1077670,1047670,1017670,987670,957670,927670,897670,867670,837670],
    [9240,9260,1296470,1241240,1082040,1052040,1022040,992040,962040,932040,902040,872040,842040],
    [9260,9280,1303290,1245890,1086400,1056400,1026400,996400,966400,936400,906400,876400,846400],
    [9280,9300,1310120,1250550,1090770,1060770,1030770,1000770,970770,940770,910770,880770,850770],
    [9300,9320,1316940,1255200,1095140,1065140,1035140,1005140,975140,945140,915140,885140,855140],
    [9320,9340,1323770,1259860,1099510,1069510,1039510,1009510,979510,949510,919510,889510,859510],
    [9340,9360,1330590,1264520,1103880,1073880,1043880,1013880,983880,953880,923880,893880,863880],
    [9360,9380,1337420,1269170,1108240,1078240,1048240,1018240,988240,958240,928240,898240,868240],
    [9380,9400,1344240,1273830,1112610,1082610,1052610,1022610,992610,962610,932610,902610,872610],
    [9400,9420,1351070,1278480,1116980,1086980,1056980,1026980,996980,966980,936980,906980,876980],
    [9420,9440,1357890,1283140,1121350,1091350,1061350,1031350,1001350,971350,941350,911350,881350],
    [9440,9460,1364720,1289840,1125720,1095720,1065720,1035720,1005720,975720,945720,915720,885720],
    [9460,9480,1371540,1296630,1130080,1100080,1070080,1040080,1010080,980080,950080,920080,890080],
    [9480,9500,1378370,1303420,1134450,1104450,1074450,1044450,1014450,984450,954450,924450,894450],
    [9500,9520,1385190,1310210,1138820,1108820,1078820,1048820,1018820,988820,958820,928820,898820],
    [9520,9540,1392020,1317000,1143190,1113190,1083190,1053190,1023190,993190,963190,933190,903190],
    [9540,9560,1398840,1323790,1147560,1117560,1087560,1057560,1027560,997560,967560,937560,907560],
    [9560,9580,1405670,1330580,1151920,1121920,1091920,1061920,1031920,1001920,971920,941920,911920],
    [9580,9600,1412490,1337370,1156290,1126290,1096290,1066290,1036290,1006290,976290,946290,916290],
    [9600,9620,1419320,1344160,1160660,1130660,1100660,1070660,1040660,1010660,980660,950660,920660],
    [9620,9640,1426140,1350950,1165030,1135030,1105030,1075030,1045030,1015030,985030,955030,925030],
    [9640,9660,1432970,1357740,1169400,1139400,1109400,1079400,1049400,1019400,989400,959400,929400],
    [9660,9680,1439790,1364530,1173760,1143760,1113760,1083760,1053760,1023760,993760,963760,933760],
    [9680,9700,1446620,1371320,1178130,1148130,1118130,1088130,1058130,1028130,998130,968130,938130],
    [9700,9720,1453440,1378110,1182500,1152500,1122500,1092500,1062500,1032500,1002500,972500,942500],
    [9720,9740,1460270,1384900,1186870,1156870,1126870,1096870,1066870,1036870,1006870,976870,946870],
    [9740,9760,1467090,1391690,1191240,1161240,1131240,1101240,1071240,1041240,1011240,981240,951240],
    [9760,9780,1473920,1398480,1195600,1165600,1135600,1105600,1075600,1045600,1015600,985600,955600],
    [9780,9800,1480740,1405270,1199970,1169970,1139970,1109970,1079970,1049970,1019970,989970,959970],
    [9800,9820,1487570,1412060,1204340,1174340,1144340,1114340,1084340,1054340,1024340,994340,964340],
    [9820,9840,1494390,1418850,1208710,1178710,1148710,1118710,1088710,1058710,1028710,998710,968710],
    [9840,9860,1501220,1425640,1213080,1183080,1153080,1123080,1093080,1063080,1033080,1003080,973080],
    [9860,9880,1508040,1432430,1217440,1187440,1157440,1127440,1097440,1067440,1037440,1007440,977440],
    [9880,9900,1514870,1439220,1221810,1191810,1161810,1131810,1101810,1071810,1041810,1011810,981810],
    [9900,9920,1521690,1446010,1226180,1196180,1166180,1136180,1106180,1076180,1046180,1016180,986180],
    [9920,9940,1528520,1452800,1230550,1200550,1170550,1140550,1110550,1080550,1050550,1020550,990550],
    [9940,9960,1535340,1459590,1234920,1204920,1174920,1144920,1114920,1084920,1054920,1024920,994920],
    [9960,9980,1542170,1466380,1239280,1209280,1179280,1149280,1119280,1089280,1059280,1029280,999280],
    [9980,10000,1548990,1473170,1243650,1213650,1183650,1153650,1123650,1093650,1063650,1033650,1003650],
    [10000,99999999999999,1552400,1476570,1245840,1215840,1185840,1155840,1125840,1095840,1065840,1035840,1005840],
];

</script>

<style>

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/*
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
body, div, span, h1, h2, h3, h4, h5, table, input { font-family: 'Noto Sans KR', sans-serif !important; }
*/

body {
    font-size:15px;
    
}

div.container {
    padding: 0px
}

.sv-title-actions__title {
    font-size:15px;
}

div.panel-body {
    padding : 0;
}

.sv_bootstrap_css .sv_qstn {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

div.small {
    padding-bottom: 5px;
}

@media only screen and (min-width: 1200px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: -1px !important;
    }
}

@media only screen and (max-width: 770px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 4px !important;
    }
}

@media only screen and (max-width: 600px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 0px !important;
    }
}

</style>
